var _CustomNextImage;
import { CustomNextImage } from '@crehana/next';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var EmptySessions = function EmptySessions(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle;
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-flex tw-flex-col tw-items-center tw-gap-2 tw-justify-center tw-h-[420px] tw-rounded-[20px] tw-bg-neutral-light-100 dark:tw-bg-elevation-dark-02",
    children: [_CustomNextImage || (_CustomNextImage = /*#__PURE__*/_jsx(CustomNextImage, {
      src: "https://crehana-vercel-images-prd.imgix.net/public/b2b-admin-mf/ad75ba16-2458-4329-9aa1-9c6518bff78f-group-334243.png?auto=format&fit=clip&w=172&h=140",
      width: 172,
      height: 140
    })), /*#__PURE__*/_jsxs("div", {
      className: "tw-w-[325px]",
      children: [/*#__PURE__*/_jsx("h3", {
        className: "tw-font-subtitle5 tw-text-center tw-mb-0.4 dark:tw-text-secondary-dark-500",
        children: title
      }), subtitle && /*#__PURE__*/_jsx("p", {
        className: "tw-font-body5 tw-text-neutral-light-700 dark:tw-text-neutral-dark-400 tw-text-center",
        children: subtitle
      })]
    })]
  });
};